import messagesEn from "./en.json";
import messagesZh from "./zh.json";
import messagesTw from "./tw.json";
import messagesFr from "./fr.json";
import messagesJa from "./ja.json";
import messagesKo from "./ko.json";
import messagesVi from "./vi.json";
import messagesEs from "./es.json";
import messagesPt from "./pt.json";


export const messages: Record<string, Record<string, string>> = {
    en: messagesEn,
    zh: messagesZh,
    tw: messagesTw,
    fr: messagesFr,
    ja: messagesJa,
    ko: messagesKo,
    vi: messagesVi,
    es: messagesEs,
    pt: messagesPt,
};